import { render, staticRenderFns } from "./AdsCampaigns.vue?vue&type=template&id=7610b7bb&scoped=true"
import script from "./AdsCampaigns.vue?vue&type=script&lang=js"
export * from "./AdsCampaigns.vue?vue&type=script&lang=js"
import style0 from "./AdsCampaigns.vue?vue&type=style&index=0&id=7610b7bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7610b7bb",
  null
  
)

export default component.exports